"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectCard = void 0;
const PlayerInputTypes_1 = require("../PlayerInputTypes");
class SelectCard {
    constructor(title, buttonLabel = 'Save', cards, cb, config) {
        var _a, _b, _c, _d, _e;
        this.title = title;
        this.buttonLabel = buttonLabel;
        this.cards = cards;
        this.cb = cb;
        this.inputType = PlayerInputTypes_1.PlayerInputTypes.SELECT_CARD;
        this.buttonLabel = buttonLabel;
        this.config = {
            max: (_a = config === null || config === void 0 ? void 0 : config.max) !== null && _a !== void 0 ? _a : 1,
            min: (_b = config === null || config === void 0 ? void 0 : config.min) !== null && _b !== void 0 ? _b : 1,
            selectBlueCardAction: (_c = config === null || config === void 0 ? void 0 : config.selectBlueCardAction) !== null && _c !== void 0 ? _c : false,
            enabled: config === null || config === void 0 ? void 0 : config.enabled,
            played: (_d = config === null || config === void 0 ? void 0 : config.played) !== null && _d !== void 0 ? _d : true,
            showOwner: (_e = config === null || config === void 0 ? void 0 : config.showOwner) !== null && _e !== void 0 ? _e : false,
        };
    }
}
exports.SelectCard = SelectCard;
//# sourceMappingURL=SelectCard.js.map